import { SVGProps } from 'react';

export const HtmlIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="16"
      height="16"
      viewBox="0 -20.5 154 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M75.6451 7.00177C92.1068 7.00177 105.452 38.3918 105.452 77.1133C105.452 111.539 94.9036 140.17 80.995 146.099"
        stroke="#009684"
        strokeWidth="14"
        strokeLinecap="round"
      />
      <path
        d="M79.2581 147.002C62.7964 147.002 49.4516 115.408 49.4516 76.435C49.4516 41.7858 59.9997 12.9693 73.9082 7.00177"
        stroke="#009684"
        strokeWidth="14"
        strokeLinecap="round"
      />
      <circle cx="77" cy="77.0018" r="70" transform="rotate(90 77 77.0018)" stroke="#009684" strokeWidth="14" />
      <line x1="147" y1="78.1308" x2="7" y2="78.1308" stroke="#009684" strokeWidth="14" />
    </svg>
  );
};
